import { v4 as uuidv4 } from 'uuid';
import request from './client';

let cartWriteQueue = Promise.resolve();

// Overlapping /cart/update.js requests lose attribute updates (a stale write
// restores the previous attribute map), so attribute writers run one at a time.
export const queueCartWrite = (write) => {
  const result = cartWriteQueue.then(write);

  cartWriteQueue = result.catch(() => {});

  return result;
};

export default class Cart {
  getCartData = () => request.get('/cart.js');

  changeCartItem = ({
    id,
    variantId,
    quantity,
    isSubscription
  }) => {
    let params = {
      id,
      quantity
    };

    if (isSubscription) {
      params = Object.assign(params, this.subscriptionProperties({ variantId }));
    } else {
      params = Object.assign(params, {
        selling_plan: null,
        properties: {
          _subscription_id: null
        }
      });
    }

    return request.post('/cart/change.js', params);
  };

  removeCartItem = ({ key }) => request.post('/cart/change.js', { quantity: 0, id: key });

  subscriptionProperties = ({ variantId }) => {
    const variantData = window.variantDataSelector.getData(variantId);

    return {
      selling_plan: variantData.sellingPlan,
      properties: {
        _subscription_id: variantData.subscriptionId
      }
    };
  };

  addBundle = ({ items }) => {
    const bundleId = uuidv4();
    const params = {
      items: items.map((item) => ({
        ...item,
        properties: {
          bundle_id: bundleId
        }
      }))
    };

    return request.post('/cart/add.js', params);
  };

  removeBundle = ({ items }) => {
    const params = {
      updates: items.reduce((result, item) => ({ ...result, ...{ [item.key]: 0 }}), {})
    };

    return queueCartWrite(() => request.post('/cart/update.js', params));
  };

  addCartItem = ({
    isSubscription = false,
    quantity,
    variantId
  }) => {
    let params = { quantity, id: variantId };

    if (isSubscription) {
      params = Object.assign(params, this.subscriptionProperties({ variantId }));
    }

    return request.post('/cart/add.js', params);
  };
}
